import {
  get_time,
  scroll_to_bottom,
  get_messages,
  get_date_from_now,
  is_date_change,
  send_message,
  set_typing,
  is_image,
  get_avatar_html,
} from './wachat_utils';

export default class WachatSpace {
  constructor(opts) {
    this.wachat_list = opts.wachat_list;
    this.$wrapper = opts.$wrapper;
    this.profile = opts.profile;

    this.lasttime = frappe.datetime.now_datetime();
    this.type_msg = null;
    this.timediff = 24;
    this.file = null;

   
    this.pageSize = 10; 
    this.displayStart = 0; 
    this.displayEnd = 0; 
    this.allMessages = []; 
    

    this.setup();
    this.has_events = false;

  }

  setup() {
    this.$wachat_space = $(document.createElement('div'));
    this.typing = false;
    this.$wachat_space.addClass('wachat-space');
    this.setup_header();
    this.fetch_and_setup_messages();
    this.setup_socketio();
  }

  setup_header() {
    this.avatar_html = get_avatar_html(
      this.profile.room_type,
      this.profile.opposite_person_email,
      this.profile.room_name
    );
    const header_html = `
        <div class='wachat-header'>
            ${
              this.profile.is_admin === true
                ? `<span class='wachat-back-button' title='${__('Go Back')}' >
                                    ${frappe.utils.icon('left')}
                                </span>`
                : ``
            }
            ${this.avatar_html}
            <div class='wachat-profile-info'>
                <div class='wachat-profile-name'>
                ${__(this.profile.room_name.substring(0,20))}
                <div class='online-circle'></div>
                </div>
                <div class='wachat-profile-status'>${__('Typing...')}</div>
            </div>
        </div>
    `;
    this.$wachat_space.append(header_html);
  }


  async fetch_and_setup_messages() {
    try {
      const res = await get_messages(
        this.profile.room,
        this.profile.user_email
      );

      this.allMessages = Array.isArray(res) ? res.slice() : [];

   
      const total = this.allMessages.length;
      this.displayEnd = total; 
      this.displayStart = Math.max(0, total - this.pageSize);

      this.setup_messages(); 
      this.setup_actions();
      this.render();
    } 
    catch (error) {
      // frappe.msgprint({
      //   title: __('Error'),
      //   message: __('Something went wrong. Please refresh and try again.'),
      // });
      console.error("Message Fetch Error:", error);
    }
  }


  setup_messages() {
    this.$wachat_space_container = $(document.createElement('div'));
    this.$wachat_space_container.addClass('wachat-space-container');
    this.$wachat_space.append(this.$wachat_space_container);


    this.$wachat_messages = $(document.createElement('div'));
    this.$wachat_messages.addClass('wachat-messages');
    this.$wachat_space_container.append(this.$wachat_messages);

    this.$floating_btn_wrap = $(`
        <div class="wachat-floating-load" style="
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 43px;
            z-index: 50;
            pointer-events: none; /* wrapper should not block clicks */
        "></div>
    `);

    this.$floating_btn = $(`
        <button class="wachat-load-prev-btn" style="
            pointer-events: auto;
            padding: 6px 14px;
            background: #ffffff;
            border: 1px solid #e0e0e0;
            border-radius: 18px;
            font-size: 13px;
            cursor: pointer;
            box-shadow: 0 2px 6px rgba(0,0,0,0.08);
        ">${__('Show Previous')}</button>
    `);

    this.$floating_btn_wrap.append(this.$floating_btn);
    this.$wachat_space.append(this.$floating_btn_wrap);

    this.updateFloatingButtonVisibility();

    this.$floating_btn.on('click', () => {
      this.loadPreviousBatch();
    });

    const me = this;
    this.$wachat_space_container.on('scroll', function () {
      const top = me.$wachat_space_container.scrollTop();
      me.updateFloatingButtonVisibility();
    });

    this.renderVisibleMessages({ scrollToBottom: true });
  }


  updateFloatingButtonVisibility() {
    const olderExist = this.displayStart > 0;
    if (olderExist) {
      this.$floating_btn_wrap.show();
    } else {
      this.$floating_btn_wrap.hide();
    }
  }


  renderVisibleMessages({ scrollToBottom = false } = {}) {

    this.$wachat_messages.empty();

 
    this.prevMessage = {};
    
    const slice = this.allMessages.slice(this.displayStart, this.displayEnd);


    slice.forEach((element) => {
 
      const date_line_html = this.make_date_line_html(element.creation);
      if (date_line_html) {
        this.$wachat_messages.append($(date_line_html));
      }

  
      let message_type = 'recipient';

      if (element.sender_email === this.profile.user_email) {
        message_type = 'recipient';
      } else if (this.profile.room_type === 'Guest') {
        if (this.profile.is_admin === true && element.sender !== 'Guest') {
          message_type = 'recipient';
        }
      }
      if (element.client == 1) {
        message_type = 'sender';
      }
      if (message_type == 'sender' && element.is_template == 0) {
        this.lasttime = element.creation;
        this.timediff = frappe.datetime.get_hour_diff(frappe.datetime.now_datetime(), this.lasttime);
      }
      const waId = element.message_id || element.name || "";
      const $msgEl = this.make_message(
        element.content,
        element.attachment,
        get_time(element.creation),
        message_type,
        element.sender,
        element.status
      );
      this.$wachat_messages.append($msgEl);

      this.prevMessage = element;
    });

    this.updateFloatingButtonVisibility();

    if (scrollToBottom) {
      scroll_to_bottom(this.$wachat_space_container);
    }
  }

  loadPreviousBatch() {
    if (this.displayStart <= 0) {
      this.updateFloatingButtonVisibility();
      return;
    }

    const container = this.$wachat_space_container[0];
    const oldScrollHeight = container.scrollHeight;
    const oldScrollTop = container.scrollTop;

    const newStart = Math.max(0, this.displayStart - this.pageSize);
    this.displayStart = newStart;

    this.renderVisibleMessages({ scrollToBottom: false });

    setTimeout(() => {
      const newScrollHeight = container.scrollHeight;
      container.scrollTop = newScrollHeight - oldScrollHeight + oldScrollTop;
    }, 10);
  }

  make_messages_html(messages_list) {
    this.prevMessage = {};
    this.message_html = ``;
    if (this.profile.message) {
      messages_list.push(this.profile.message);
      send_message(
        this.profile.message.content,
        this.profile.user,
        this.profile.room,
        this.profile.user_email
      );
    }
    messages_list.forEach((element) => {
      const date_line_html = this.make_date_line_html(element.creation);
      this.message_html += date_line_html;

      let message_type = 'recipient';

      if (element.sender_email === this.profile.user_email) {
        message_type = 'recipient';
      } else if (this.profile.room_type === 'Guest') {
        if (this.profile.is_admin === true && element.sender !== 'Guest') {
          message_type = 'recipient';
        }
      }
      if (element.client == 1) {
        message_type = 'sender';
      }
      if (message_type == 'sender' && element.is_template == 0){
        this.lasttime = element.creation;
        this.timediff = frappe.datetime.get_hour_diff(frappe.datetime.now_datetime(),this.lasttime);
      }
      const waId2 = element.message_id || element.name || "";
      this.message_html += this.make_message(
        element.content,
        element.attachment,
        get_time(element.creation),
        message_type,
        element.sender,
        element.status
      ).prop('outerHTML');

      this.prevMessage = element;
    });
  }

  make_date_line_html(dateObj) {
    let result = `
        <div class='date-line'>
            <span>
                ${__(get_date_from_now(dateObj, 'space'))}
            </span>
        </div>
    `;
    if ($.isEmptyObject(this.prevMessage)) {
      return result;
    } else if (is_date_change(dateObj, this.prevMessage.creation)) {
      return result;
    } else {
      return '';
    }
  }

  setup_actions() {
    this.$wachat_actions = $(document.createElement('div'));
    this.$wachat_actions.addClass('wachat-space-actions');

    // Input field
    this.type_msg = `
        <input ${this.timediff >= 23 ? 'disabled' : ''} class='form-control type-message' 
            type='search' 
            placeholder='${this.timediff >= 23 ? __('Exceeded 24 Hrs Send Templates') : __('Type message')}'
        >
    `;

    // Action buttons HTML
    const wachat_actions_html = `
        <span class='open-attach-items'>
            ${frappe.utils.icon('attachment', 'lg')}
        </span>
        <input type='file' id='wachat-file-uploader' 
            accept='image/*, application/pdf, .doc, .docx'
            style='display: none;'
        >
        ${this.type_msg}
        <div>
            <span class='message-send-button'>
                <svg xmlns="http://www.w3.org/2000/svg" width="1.1rem" height="1.1rem" viewBox="0 0 24 24">
                    <path d="M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z"/>
                </svg>
            </span>
        </div>
    `;
    this.$wachat_actions.html(wachat_actions_html);

    // Reply preview
    this.$reply_preview = $(`
        <div class="wachat-reply-preview" style="
            display: none;
            padding: 6px 12px;
            background: #f2f2f2;
            border-left: 3px solid #00a2ff;
            margin-bottom: 5px;
            font-size: 13px;
            position: relative;
        ">
            <span class="wachat-reply-sender" style="font-weight: bold;"></span>
            <span class="wachat-reply-text"></span>
            <span class="wachat-reply-close" style="
                position: absolute;
                right: 8px;
                cursor: pointer;
                font-weight: bold;
            ">×</span>
        </div>
    `);

    // Close button handler
    // this.$reply_preview.find('.wachat-reply-close').on('click', () => {
    //     this.$reply_preview.hide();
    //     this.reply_to = null;
    // });

    this.$reply_preview.find('.wachat-reply-close')
        .off('click')
        .on('click', () => {
          this.$reply_preview.hide();
          this.reply_to = null;
        });


    // Append reply preview **inside the actions container, above input**
    this.$wachat_actions.prepend(this.$reply_preview);

    // Append actions to chat space
    this.$wachat_space.append(this.$wachat_actions);
}


  async handle_upload_file(file) {
    const dataurl = await frappe.dom.file_to_base64(file.file_obj);
    file.dataurl = dataurl;
    file.name = file.file_obj.name;
    return this.upload_file(file);
  }

  upload_file(file) {
    const me = this;
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('load', () => {
        resolve();
      });

      xhr.addEventListener('error', () => {
        reject(frappe.throw(__('Internal Server Error')));
      });
      xhr.onreadystatechange = () => {
        if (xhr.readyState == XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            let r = null;
            let file_doc = null;
            try {
              r = JSON.parse(xhr.responseText);
              if (r.message.doctype === 'File') {
                file_doc = r.message;
              }
            } catch (e) {
              r = xhr.responseText;
            }
            try {
              if (file_doc === null) {
                reject(frappe.throw(__('File upload failed!')));
              }
              me.handle_send_message(file_doc.file_url);
            } catch (error) {
          
            }
          } else {
            try {
              const error = JSON.parse(xhr.responseText);
              const messages = JSON.parse(error._server_messages);
              const errorObj = JSON.parse(messages[0]);
              reject(frappe.throw(__(errorObj.message)));
            } catch (e) {
     
            }
          }
        }
      };

      xhr.open('POST', '/api/method/upload_file', true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Frappe-CSRF-Token', frappe.csrf_token);

      let form_data = new FormData();

      form_data.append('file', file.file_obj, file.name);
      form_data.append('is_private', +false);

      form_data.append('doctype', 'Wachat Room');
      form_data.append('docname', this.profile.room);
      form_data.append('optimize', +true);
      xhr.send(form_data);
    });
  }

  open_file_uploader() {
    const me = this;
    let restrictions = {
      allowed_file_types: []
    };
    let options = {
      allow_multiple: true,
      restrictions: restrictions,
      on_success: (file) => {
        frappe.db.get_doc('File', file.name)
        .then(filedoc => {
          console.log(filedoc);
          this.$wachat_messages.append(
            this.make_message('Media Attachment', filedoc.file_url, get_time(), 'recipient', this.profile.user)
          );
          this.allMessages.push({
            content: filedoc.file_url,
            attachment: filedoc.file_url,
            sender: this.profile.user,
            creation: frappe.datetime.now_datetime(),
            sender_email: this.profile.user_email,
            client: 0,
            is_template: 0
          });
          this.displayEnd = this.allMessages.length;
          if (this.displayEnd - this.displayStart > this.pageSize) {
            this.displayStart = Math.max(0, this.displayEnd - this.pageSize);
          }
          scroll_to_bottom(this.$wachat_space_container);
        });
        alert('Success');
      },
    };
    options.doctype = 'Wachat Room';
    options.docname = this.profile.room;
    options.disable_file_browser = 1;
    new frappe.ui.FileUploader(options);
  }

  setup_events() {
    const me = this;

    me.typing_timeout = () => {
      me.typing = false;
    };

    $('.wachat-back-button').on('click', function () {
      me.wachat_list.render();
      me.wachat_list.render_messages();
      me.wachat_list.setup_events();
      me.wachat_list.show_load_more_button();
    });

    $('.open-attach-items').on('click', function () {
      me.open_file_uploader();
    });

    $('#wachat-file-uploader').on('change', function () {
      if (this.files.length > 0) {
        me.file = {};
        me.file.file_obj = this.files[0];
        me.handle_upload_file(me.file);
        me.file = null;
      }
    });

    $('.message-send-button').on('click', function () {
      me.handle_send_message();
    });

    $(document).on('keydown', '.type-message', function (e) {
      if (e.which === 13) {
        me.handle_send_message();
      } else {
        //Set as typing
        if (me.typing === false) {
          me.typing = true;
          set_typing(
            me.profile.room,
            me.profile.user_email,
            me.typing,
            !me.profile.is_admin
          );
          me.timeout = setTimeout(me.typing_timeout, 3000);
        }
      }
    });
    // Right-click on any message to trigger reply
    this.$wachat_space_container.on('contextmenu', '.sender-message, .recipient-message', (e) => {
        e.preventDefault();
        const $msg = $(e.currentTarget);
        const msgId = $msg.attr("data-message-id") || ""
        const sender = $msg.find('.message-name').text() || '';
        const text = $msg.find('.message-bubble').text() || '';

        this.reply_to = {
            id: msgId,
            sender: sender,
            text: text
        };
        // Close reply preview
        this.$reply_preview.find('.wachat-reply-close').on('click', () => {
            this.$reply_preview.hide();
            this.reply_to = null;
        });
        this.$reply_preview.find('.wachat-reply-sender').text(sender + ': ');
        this.$reply_preview.find('.wachat-reply-text').text(text);
        this.$reply_preview.show();
    });

  }

  setup_socketio() {
    const me = this;

    frappe.realtime.on(this.profile.room, function (res) {
      me.receive_message(res, get_time(res.creation));
    });

    frappe.realtime.on(this.profile.room + ':typing', function (res) {
      me.get_typing_changes(res);
    });
  }

  destroy_socket_events() {
    frappe.realtime.off(this.profile.room);
    frappe.realtime.off(this.profile.room + ':typing');
  }

  get_typing_changes(res) {
    if (res.user != this.profile.user_email) {
      if (
        (this.profile.is_admin === true && res.is_guest === 'true') ||
        this.profile.is_admin === false ||
        this.profile.room_type === 'Group' ||
        this.profile.room_type === 'Direct'
      ) {
        if (res.is_typing === 'false') {
          $('.wachat-profile-status').css('visibility', 'hidden');
        } else {
          $('.wachat-profile-status').css('visibility', 'visible');
          const timeout = setTimeout(() => {
            $('.wachat-profile-status').css('visibility', 'hidden');
          }, 3000);
        }
      }
    }
  }

  make_message(content, attachment, time, type, name, status, wa_id = "") {
    const message_class =
      type === 'recipient' ? 'recipient-message' : 'sender-message';
    const $recipient_element = $(document.createElement('div')).addClass(
      message_class
    );

    $recipient_element.attr("data-message-id", wa_id || "");

    const $message_element = $(document.createElement('div')).addClass(
      'message-bubble'
    );

    const $name_element = $(document.createElement('div'))
      .addClass('message-name')
      .text(name);

    const $attach_element = $(document.createElement('div'))
      .addClass('message-name')
      .text('Media Attachment');

    const $caption_element = $(document.createElement('div'))
      .addClass('message-caption')
      .text("Caption: " + content);

    const n = (content || '').lastIndexOf('/');
    const file_name = content ? content.substring(n + 1) : '';
    let $sanitized_content;

    if (content && content.startsWith('/files/') && file_name !== '') {
      let $url;
      if (is_image(file_name)) {
        $url = $(document.createElement('img'));
        $url.attr({ src: content }).addClass('img-responsive wachat-image');
        $message_element.css({ padding: '0px', background: 'inherit' });
        $name_element.css({
          color: 'var(--text-muted)',
          'padding-bottom': 'var(--padding-xs)',
        });
      } else {
        $url = $(document.createElement('a'));
        $url.attr({ href: attachment, target: '_blank' }).text(__('Download'));

        if (type === 'sender') {
          $url.css('color', 'var(--cyan-100)');
        }
      }
      $sanitized_content = $url;
    } else if ((attachment) && (attachment !== '') && (attachment.startsWith('https'))) {
      let $url;
      if (is_image(file_name)) {
        $url = $(document.createElement('img'));
        $url.attr({ src: content }).addClass('img-responsive wachat-image');
        $message_element.css({ padding: '0px', background: 'inherit' });
        $name_element.css({
          color: 'var(--text-muted)',
          'padding-bottom': 'var(--padding-xs)',
        });
      } else {
        $url = $(document.createElement('a'));
        $url.attr({ href: attachment, target: '_blank' }).text(__('Download'));

        if (type === 'sender') {
          $url.css('color', 'var(--cyan-100)');
        }
      }
      $message_element.append($attach_element);
      $message_element.append($caption_element);
      $sanitized_content = $url;
    } else {
      $sanitized_content = __($('<div>').text(content).html());
    }

    if (type === 'sender' && this.profile.room_type === 'Group') {
      $message_element.append($name_element);
    }
    $message_element.append($sanitized_content);
    $recipient_element.append($message_element);
    $recipient_element.append(`<div class='message-time'>${__(time)}</div>`);
    if (type === 'recipient') {
      $recipient_element.append(`<div class='message-time'>Sent by ${name}</div>`);
    }
    if (status) {
      $recipient_element.append(`<div class='message-time'>Msg Status: ${status}</div>`);
    }
    return $recipient_element;
  }

  handle_send_message(attachment) {
    const $type_message = $('.type-message');
    let content = null;

    if (attachment) {
      content = attachment;
    } else {
      content = $type_message.val();
    }

    if (!content || content.length === 0) {
      return;
    }
    this.typing = false;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (
      this.profile.is_admin === true &&
      frappe.Wachat.settings.user.enable_message_tone === 1
    ) {
      frappe.utils.play_sound('wachat-message-send');
    }

    const now = frappe.datetime.now_datetime();
    const localMsg = {
      content: content,
      attachment: attachment || '',
      sender: this.profile.user,
      creation: now,
      sender_email: this.profile.user_email,
      client: 1,
      is_template: 0,
      message_id: "local-" + Date.now()
    };

    this.allMessages.push(localMsg);

    this.displayEnd = this.allMessages.length;
    if (this.displayEnd - this.displayStart > this.pageSize) {
      this.displayStart = Math.max(0, this.displayEnd - this.pageSize);
    }

    if (this.displayEnd - this.displayStart <= this.pageSize) {
      this.$wachat_messages.append(
        this.make_message(content, attachment, get_time(now), 'recipient', this.profile.user)
      );
      scroll_to_bottom(this.$wachat_space_container);
    } else {
      this.renderVisibleMessages({ scrollToBottom: true });
    }

    const reply_id = this.reply_to ? (this.reply_to.id || "") : "";


    $type_message.val('');
    // this.reply_to = null; // Reset reply
    this.$reply_preview.hide(); // Hide reply preview

    send_message(
      content,
      this.profile.user,
      this.profile.room,
      this.profile.user_email,
      this.reply_to?.id || ""
    );
    this.updateFloatingButtonVisibility();
    this.reply_to = null;
    this.$reply_preview.hide();
  }

  receive_message(res, time) {
    if (res.sender_email === this.profile.user_email) {
      return;
    }

    let wachat_type = 'sender';
    if (this.profile.room_type === 'Guest') {
      if (this.profile.is_admin === true && res.user !== 'Guest') {
        wachat_type = 'recipient';
      }
    }

    const incoming = {
      content: res.content,
      attachment: res.content,
      sender: res.user,
      creation: res.creation || frappe.datetime.now_datetime(),
      sender_email: res.sender_email,
      client: 0,
      is_template: 0,
      status: res.status || ''
    };

    this.allMessages.push(incoming);

    const total = this.allMessages.length;
    if (this.displayEnd === total - 1 || this.displayEnd === total) {
      const waIdIncoming = res.message_id || res.messageId || "";
      this.$wachat_messages.append(
        this.make_message(incoming.content, incoming.attachment, time, wachat_type, incoming.sender, incoming.status, waIdIncoming)
      );
      scroll_to_bottom(this.$wachat_space_container);
      this.displayEnd = this.allMessages.length;
      if (this.displayEnd - this.displayStart > this.pageSize) {
        this.displayStart = Math.max(0, this.displayEnd - this.pageSize);
      }
    } else {
      this.displayEnd = this.allMessages.length;
      if (this.displayEnd - this.displayStart > this.pageSize) {
        this.displayStart = Math.max(0, this.displayEnd - this.pageSize);
      }
      this.renderVisibleMessages({ scrollToBottom: true });
    }

    if (
      this.profile.is_admin === true &&
      $('.wachat-element').is(':visible') &&
      frappe.Wachat.settings.user.enable_message_tone === 1
    ) {
      frappe.utils.play_sound('wachat-message-receive');
    }
    this.updateFloatingButtonVisibility();
  }

  render() {
    this.$wrapper.html(this.$wachat_space);
    // this.setup_events();
    if (!this.has_events) {
      this.setup_events();
      this.has_events = true;
    }

    scroll_to_bottom(this.$wachat_space_container);
  }
}
